import { post } from "../../utils/Backend";
import {
  mockGetOrCreateConversation,
  mockGetSpaceCsEntryConfig,
  mockListMessages,
  mockMarkRead,
  mockPollNewMessages,
  mockSendMessage,
} from "./CustomerServiceChatMock";
import type {
  CsChatChannel,
  CsConversationBootstrap,
  CsListMessagesResult,
  CsMessage,
  CsPollNewMessagesResult,
} from "./CustomerServiceChatTypes";

const mock = false;

const BASE = "/lark/app/customerService";

export type SpaceCsEntryConfig = {
  enabled: boolean;
  entryDisplayName: string;
};

export const CustomerServiceChatApi = {
  async getOrCreateConversation(
    csChannel: CsChatChannel = "PLATFORM",
    spaceId?: string
  ): Promise<CsConversationBootstrap | string> {
    if (mock && false) {
      return mockGetOrCreateConversation();
    }
    return post<
      { csChannel?: string; spaceId?: string },
      CsConversationBootstrap
    >(`${BASE}/getOrCreateConversation`, {
      csChannel,
      spaceId: spaceId?.trim() || undefined,
    });
  },

  async getSpaceCsEntryConfig(spaceId: string): Promise<SpaceCsEntryConfig> {
    if (mock && false) {
      return mockGetSpaceCsEntryConfig(spaceId);
    }
    const res = await post<
      { spaceId: string },
      { enabled?: boolean; entryDisplayName?: string }
    >(`${BASE}/getSpaceCsEntryEnabled`, { spaceId });
    if (typeof res === "string") {
      return { enabled: false, entryDisplayName: "服务专员" };
    }
    return {
      enabled: res?.enabled !== false,
      entryDisplayName: res?.entryDisplayName?.trim() || "服务专员",
    };
  },

  /** @deprecated 使用 getSpaceCsEntryConfig */
  async getSpaceCsEntryEnabled(spaceId: string): Promise<boolean> {
    const config = await this.getSpaceCsEntryConfig(spaceId);
    return config.enabled;
  },

  async listMessages(
    conversationId: string,
    beforeMessageId?: string | null,
    size = 30
  ): Promise<CsListMessagesResult | string> {
    if (mock && false) {
      return mockListMessages(beforeMessageId);
    }
    return post<
      { conversationId: string; beforeMessageId?: string; size?: number },
      CsListMessagesResult
    >(`${BASE}/listMessages`, {
      conversationId,
      beforeMessageId: beforeMessageId ?? undefined,
      size,
    });
  },

  async pollNewMessages(
    conversationId: string,
    afterMessageId?: string | null,
    afterRecallEventId?: string | null
  ): Promise<CsPollNewMessagesResult | string> {
    if (mock && false) {
      return mockPollNewMessages(afterMessageId);
    }
    return post<
      { conversationId: string; afterMessageId?: string; afterRecallEventId?: string },
      CsPollNewMessagesResult
    >(`${BASE}/pollNewMessages`, {
      conversationId,
      afterMessageId: afterMessageId ?? undefined,
      afterRecallEventId: afterRecallEventId ?? undefined,
    });
  },

  async sendMessage(
    conversationId: string,
    content: string,
    messageType: "TEXT" | "IMAGE" = "TEXT"
  ): Promise<CsMessage | string> {
    if (mock && false) {
      return mockSendMessage(content);
    }
    return post<
      { conversationId: string; content: string; messageType?: string },
      CsMessage
    >(`${BASE}/sendMessage`, { conversationId, content, messageType });
  },

  async markRead(conversationId: string): Promise<boolean | string> {
    if (mock && false) {
      return mockMarkRead();
    }
    return post<{ conversationId: string }, boolean>(
      `${BASE}/markRead`,
      { conversationId }
    );
  },

  async prepareImageUpload(
    conversationId: string,
    fileExt: string
  ): Promise<{ objectKey: string } | string> {
    if (mock && false) {
      return { objectKey: `cs/${conversationId}/mock.${fileExt}` };
    }
    return post<{ conversationId: string; fileExt: string }, { objectKey: string }>(
      `${BASE}/prepareImageUpload`,
      { conversationId, fileExt }
    );
  },
};
